
import React from 'react';

const LoadingState: React.FC = () => {
  return (
    <div className="flex justify-center items-center py-12">
      <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary"></div>
      <p className="ml-2">Loading course data...</p>
    </div>
  );
};

export default LoadingState;
